import styled from "styled-components";

export const ChartContainer = styled.div`
  cursor: ${({ toolbar }) => (toolbar ? "0" : "pointer")};
  position: relative;
  margin: ${({ toolbar }) => (toolbar ? "10px 5px 0" : "10px")};
  min-width: ${(props) => props.width}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  overflow: hidden;
  background-color: rgb(38, 51, 64);
  border-radius: 10px;
  border: 1px solid white;
  transition: transform 0.2s ease-in-out;
  z-index: ${({ transitioning }) => (transitioning ? "1000" : "")};

  :hover {
    transform: ${({ toolbar }) =>
      toolbar ? "" : "scale(1.5) translateY(30px)"};
    z-index: ${({ toolbar }) => (toolbar ? "" : "1000")}1000;
  }
`;
export const PatternLine = styled.div`
  height: 1px;
  background-color: rgb(255, 255, 255);
  line-height: 1px;
  position: absolute;
  z-index: 10;
  left: ${(props) => props.line.centerX}px;
  top: ${(props) => props.marginTop + props.line.centerY}px;
  width: ${(props) => props.line.length}px;
  transform: rotate(${(props) => props.line.angle}deg);
`;

export const ChartInfo = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  p {
    margin: 1px 0;
  }
`;

export const TradingViewContainer = styled.div``;
